import React, { useEffect, useState } from "react";
import type { Column } from "react-table";

import type { IData } from "../../types";
import { CustomizedPagination } from "./CustomizedPagination";
import { CustomizedTable } from "./CustomizedTable";

export interface IPaginatedTableProps {
  columns: Column<IData>[];
  data: IData[];
  hiddenColumns?: string[];
  itemsPerPage?: number;
  totalItems?: number;
  isLoading?: boolean;
  pageIndex?: number;
  activeIndex?: number;
  onRowClick?: (row: IData) => void;
}

const PaginatedTable: React.FC<IPaginatedTableProps> = ({
  columns,
  data,
  itemsPerPage = 10,
  totalItems = 0,
  isLoading = false,
  hiddenColumns,
  pageIndex,
  activeIndex,
  onRowClick,
}) => {
  const [totItemsValue, setTotItemsValue] = useState<number>(totalItems);
  useEffect(() => {
    if (!isLoading) {
      setTotItemsValue(totalItems);
    }
  }, [totalItems, isLoading]);

  return (
    <>
      <CustomizedTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        hiddenColumns={hiddenColumns}
        activeIndex={activeIndex}
        onRowClick={onRowClick}
      />
      {!!data.length && (
        <CustomizedPagination
          totalItems={totItemsValue}
          itemsPerPage={itemsPerPage}
          pageIndex={pageIndex}
        />
      )}
    </>
  );
};

export { type IData, PaginatedTable };
